module.exports = __webpack_public_path__ + "img/hpe.41e3a2e8.svg";